const OrderTypes = Object.freeze({
    DELIVERY_ORDER: 'DELIVERY_ORDER',
    PICKUP_ORDER: 'PICKUP_ORDER',
    SERVICE_ORDER: 'SERVICE_ORDER'
})

export { OrderTypes }
